import { SHA512 } from 'crypto-js';
import { baseUrl } from '../utils/url';
import { encryptPayload, hashSignature } from '../utils/security';
import { store } from '@store/index';

const headers = { 'Content-Type': 'application/json' };

export interface SecurityCodeData {
  securityCode: string;
  newSecurityCode: string;
  verifySecurityCode: string;
}

export interface PasswordData {
  password: string;
  newPassword: string;
  verifyPassword: string;
}

export type ChangePasswordParams =
  | { route: 'security_code'; data: SecurityCodeData }
  | { route: 'password'; data: PasswordData };

export const user = {
  forgetPasswordToken: async (email: string) => {
    try {
      const res = await fetch(`${baseUrl}token`, {
        method: 'POST',
        headers: headers,
        // body: JSON.stringify({ credential: email }),
        body: encryptPayload({ credential: email }, true) as BodyInit,
      });

      return await res.json();
    } catch (error) {
      return error;
    }
  },
  verifyFPToken: async (token: string) => {
    try {
      const res = await fetch(`${baseUrl}token/${token}`, {
        method: 'POST',
        headers: headers,
      });

      return await res.json();
    } catch (error) {
      return error;
    }
  },
  changePassword: async (data: {
    verifyPassword?: string;
    password?: string;
    token: string;
    username?: string;
    securityCode?: string;
  }) => {
    try {
      let signature = '';
      if (data.username) {
        signature = SHA512(
          `${data.username}${data.password}${data.securityCode}${data.token}`,
        ).toString();
      } else {
        signature = SHA512(`${data.password}${data.token}`).toString();
      }
      // users/credential
      const res = await fetch(`${baseUrl}credentials`, {
        method: 'PUT',
        headers: headers,
        // body: JSON.stringify({ ...data, signature }),
        body: encryptPayload({ ...data, signature }, true) as BodyInit,
      });

      return await res.json();
    } catch (error) {
      return error;
    }
  },
  changePasswordOnly: async (data: {
    userID?: string;
    password?: string;
    verifyPassword?: string;
    securityCode?: string;
    token?: string;
    signature: string;
  }) => {
    try {
      const res = await fetch(`${baseUrl}credentials`, {
        method: 'PUT',
        headers: headers,
        // body: JSON.stringify(data),
        body: encryptPayload(data, true) as BodyInit,
      });

      return await res.json();
    } catch (error) {
      return error;
    }
  },
  changePasswordV2: async ({ route, data }: ChangePasswordParams) => {
    try {
      const { getState } = store;
      const storeData = getState();
      let signature: string = '';

      if (route === 'security_code') {
        signature = hashSignature(
          `${data?.securityCode}${data?.newSecurityCode}`,
        );
      } else if (route === 'password') {
        signature = hashSignature(`${data?.password}${data?.newPassword}`);
      }

      const res = await fetch(`${baseUrl}authentication/${route}`, {
        method: 'PUT',
        headers: {
          ...headers,
          'x-access-token': storeData?.user?.info?.token,
        },
        body: encryptPayload({ ...data, signature }, true) as BodyInit,
      });

      return await res.json();
    } catch (error) {
      return error;
    }
  },
  sendEmail: async (route: 'security_code' | 'password') => {
    try {
      const { getState } = store;
      const data = getState();

      const res = await fetch(`${baseUrl}authentication/${route}/send_email`, {
        headers: {
          ...headers,
          'x-access-token': data?.user?.info?.token,
        },
        method: 'POST',
      });
      return await res.json();
    } catch (error) {
      return error;
    }
  },
};
